// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddCustomerMutation($input: AddCustomerInput!) {
    addCustomer(input: $input) {
      customerEdge {
        node {
          id
          customerNumber
          name
          primaryContactName
          secondaryContactName
          email
          phone
          openOrders
          salesUser {
            ...UserAvatar_user
          }
          ...CustomerDetails_customer
          ...AddUpdateOrderModal_customer
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'PaginatedCustomersContainer_customers',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'customerEdge',
        },
      ],
    });
  },
};
